// ============================================
// Google Harita Reklam Verme - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googleHaritaReklamVermeContent: BlogContent = {
  tableOfContents: [
    { id: "kampanya-turleri", title: "Kampanya Türleri" },
    { id: "sektorel-stratejiler", title: "Sektörel Stratejiler" },
    { id: "butce-belirleme", title: "Bütçe Belirleme" },
    { id: "case-study", title: "Case Study" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google Harita reklam verme</strong>, yerel işletmeler için en etkili dijital pazarlama yöntemlerinden biridir. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Google Reklam Ajansı</a> Google Haritalar üzerinden verilen reklamların yerel işletmelere %300-500 oranında daha fazla müşteri kazandırdığını gözlemledim. Bu rehberde, Google Harita reklamlarının kampanya türlerini, sektörel stratejileri ve başarı metriklerini detaylıca paylaşacağım."
    },
    {
      type: "heading",
      value: "Kampanya Türleri",
      id: "kampanya-turleri"
    },
    {
      type: "paragraph",
      value: "<strong>Google Harita reklam kampanyaları</strong>, farklı iş hedeflerine göre özelleştirilmiş kampanya türleriyle sunulmaktadır:"
    },
    {
      type: "subheading",
      value: "1. Local Search Ads (Yerel Arama Reklamları)"
    },
    {
      type: "paragraph",
      value: "Google Haritalar'da ve Google Arama'da işletmenizin konumunu vurgulayan reklam türüdür:"
    },
    {
      type: "list",
      items: [
        "<strong>Harita Pin'i Vurgusu:</strong> İşletmeniz haritada kırmızı renkli özel bir işaretle gösterilir, rakiplerinizden görsel olarak ayrışırsınız.",
        "<strong>İşletme Profili Önceliği:</strong> 'Yakınımdaki [hizmet]' aramaları yapıldığında sonuçların en üstünde yer alırsınız.",
        "<strong>Maliyet Yapısı:</strong> Tıklama başına (CPC) ya da telefon araması başına (CPCall) ödeme yaparsınız.",
        "<strong>Dönüşüm Oranı:</strong> Yerel aramalarda %35-50 dönüşüm oranı, normal arama reklamlarından %20 daha yüksektir.",
        "<strong>En Uygun Sektörler:</strong> Restoranlar, kuaförler, klinikler, tamirciler, danışmanlık hizmetleri."
      ]
    },
    {
      type: "subheading",
      value: "2. Local Campaigns (Yerel Kampanyalar)"
    },
    {
      type: "paragraph",
      value: "Google'ın tüm platformlarında (Arama, Haritalar, Display, YouTube) otomatik olarak yayınlanan kampanyalardır:"
    },
    {
      type: "list",
      items: [
        "<strong>Otomatik Optimizasyon:</strong> Google'ın makine öğrenmesi, en iyi performansı veren kanalları otomatik seçer.",
        "<strong>Mağaza Ziyareti Hedefi:</strong> Fiziksel mağazanıza yakın kullanıcılara reklam gösterir, yönlendirme yapar.",
        "<strong>Multi-Platform Erişim:</strong> Tek kampanya ile Google Haritalar, YouTube ve Display Network'te görünürsünüz.",
        "<strong>Maliyet Avantajı:</strong> Manuel kampanyalara göre %15-20 daha düşük CPC.",
        "<strong>Performans:</strong> Müşterilerimle yaptığımız testlerde, mağaza ziyaretlerini %45 artırdı."
      ]
    },
    {
      type: "subheading",
      value: "3. Performance Max for Store Goals"
    },
    {
      type: "paragraph",
      value: "Google'ın en yeni AI tabanlı kampanya türü, mağaza hedeflerine özel optimize edilmiştir:"
    },
    {
      type: "list",
      items: [
        "<strong>AI-Powered Hedefleme:</strong> Google'ın yapay zekası, mağaza ziyareti yapma olasılığı en yüksek kullanıcıları bulur.",
        "<strong>Asset Group Stratejisi:</strong> Metin, görsel, video gibi tüm reklam formatlarını otomatik oluşturur ve test eder.",
        "<strong>Store Visits Tracking:</strong> Fiziksel mağaza ziyaretlerini doğrudan ölçer (Google Location History verisi).",
        "<strong>Bütçe Esnekliği:</strong> Minimum günlük 500 TL bütçe ile başlayabilirsiniz.",
        "<strong>ROI:</strong> Deneyimime göre, geleneksel kampanyalara göre %30-40 daha yüksek ROI sağlar."
      ]
    },
    {
      type: "subheading",
      value: "4. Display Reklamları ile Harita Entegrasyonu"
    },
    {
      type: "paragraph",
      value: "Display reklamlarınızda işletme konumunuzu göstererek awareness artırabilirsiniz:"
    },
    {
      type: "list",
      items: [
        "<strong>Location Extensions:</strong> Display reklamınızın altında işletme adresiniz ve harita gösterilir.",
        "<strong>Radius Targeting:</strong> İşletmenizin 1-50 km çevresindeki kullanıcılara hedefli reklam.",
        "<strong>Remarketing + Location:</strong> Web sitenizi ziyaret edip konumunuza yakın kullanıcılara harita reklamı gösterin.",
        "<strong>Maliyet:</strong> CPM (bin gösterim) başına 5-15 TL, awareness kampanyaları için idealdir.",
        "<strong>Kullanım Senaryosu:</strong> Yeni açılan işletmeler, etkinlik duyuruları, sezonluk promosyonlar."
      ]
    },
    {
      type: "heading",
      value: "Sektörel Stratejiler",
      id: "sektorel-stratejiler"
    },
    {
      type: "paragraph",
      value: "<strong>Google Harita reklam stratejileri</strong>, sektöre göre büyük farklılıklar gösterir. İşte <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Dijital Mustafa</a> dayalı sektörel öneriler:"
    },
    {
      type: "subheading",
      value: "Restoranlar ve Kafeler"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Tipi:</strong> Local Search Ads + Local Campaigns kombinasyonu.",
        "<strong>Hedefleme:</strong> İşletmenizin 5 km çevresindeki kullanıcılar, öğle ve akşam yemeği saatleri (11:00-14:00, 18:00-21:00).",
        "<strong>Anahtar Kelimeler:</strong> '[bölge] restoran', 'yakınımdaki [mutfak türü]', 'açık restoranlar'.",
        "<strong>Reklam Uzantıları:</strong> Menü linkleri, online rezervasyon, telefon araması, yol tarifi.",
        "<strong>Görsel Strateji:</strong> Yemek fotoğrafları, iç mekan görselleri, müşteri yorumları.",
        "<strong>Bütçe Önerisi:</strong> Günlük 200-500 TL, hafta sonları %30 artış.",
        "<strong>Başarı Metriği:</strong> Telefon aramaları, rezervasyonlar, yol tarifi tıklamaları."
      ]
    },
    {
      type: "subheading",
      value: "Sağlık Hizmetleri (Klinik, Diş, Estetik)"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Tipi:</strong> Local Search Ads (yüksek niyetli aramalar için).",
        "<strong>Hedefleme:</strong> 10-15 km yarıçap, iş saatleri (09:00-18:00), mobil cihaz önceliği %70.",
        "<strong>Anahtar Kelimeler:</strong> '[bölge] diş kliniği', 'acil diş ağrısı', '[bölge] estetik merkezi'.",
        "<strong>Yasal Uyum:</strong> Sağlık Bakanlığı reklam yönetmeliğine uygun metin kullanın.",
        "<strong>Landing Page:</strong> Online randevu formu, doktor CV'leri, tedavi bilgileri.",
        "<strong>Bütçe Önerisi:</strong> Günlük 300-800 TL, dişte tıklama başına 8-15 TL, estetik cerrahi 20-40 TL.",
        "<strong>Dönüşüm Hedefi:</strong> Telefon araması ve online form doldurmalar."
      ]
    },
    {
      type: "subheading",
      value: "Ev Hizmetleri (Tesisatçı, Elektrikçi, Tadilat)"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Tipi:</strong> Local Search Ads + Call-Only Ads.",
        "<strong>Hedefleme:</strong> Acil durumlar için 7/24 yayın, 20 km yarıçap.",
        "<strong>Anahtar Kelimeler:</strong> 'acil tesisatçı [bölge]', '24 saat elektrikçi', 'su kaçağı tamiri'.",
        "<strong>Telefon Önceliği:</strong> Call-only reklamlar kullanın, %80+ dönüşüm telefon aramasıdır.",
        "<strong>Dayparting:</strong> Gece 22:00-08:00 arası acil aramalar için teklifi %50 artırın.",
        "<strong>Bütçe Önerisi:</strong> Günlük 150-400 TL, hafta içi daha yüksek.",
        "<strong>ROI:</strong> Telefon araması başına 10-20 TL maliyet, ortalama iş değeri 500-2000 TL."
      ]
    },
    {
      type: "subheading",
      value: "Otomotiv (Servis, Yedek Parça, Oto Yıkama)"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Tipi:</strong> Local Campaigns + Performance Max.",
        "<strong>Hedefleme:</strong> Araç sahipleri (audience targeting), 15 km yarıçap.",
        "<strong>Anahtar Kelimeler:</strong> '[bölge] oto servis', 'araç bakım', 'lastik değişimi [bölge]'.",
        "<strong>Remarketing:</strong> Web sitenizi ziyaret edenlere harita reklamı gösterin.",
        "<strong>Özel Günler:</strong> Kış lastiği dönemi (Ekim-Kasım), yaz bakım sezonu (Mayıs-Haziran) bütçesini artırın.",
        "<strong>Bütçe Önerisi:</strong> Günlük 250-600 TL, sezonluk kampanyalarda %40 artış.",
        "<strong>Video Reklamlar:</strong> YouTube'da servis içi videolar ile güven oluşturun."
      ]
    },
    {
      type: "subheading",
      value: "Güzellik & Bakım (Kuaför, SPA, Güzellik Merkezi)"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya Tipi:</strong> Local Search Ads + Display Reklamları.",
        "<strong>Hedefleme:</strong> Kadın kullanıcılar %70-80, 25-45 yaş arası, 8 km yarıçap.",
        "<strong>Anahtar Kelimeler:</strong> '[bölge] kuaför', 'cilt bakımı [bölge]', 'spa masaj merkezi'.",
        "<strong>Görsel Pazarlama:</strong> Öncesi-sonrası fotoğrafları, salon iç mekan, müşteri yorumları.",
        "<strong>Appointment Booking:</strong> Google rezervasyon entegrasyonu mutlaka kullanın.",
        "<strong>Bütçe Önerisi:</strong> Günlük 200-450 TL, özel günlerde (Anneler Günü, 14 Şubat) %50 artış.",
        "<strong>Remarketing:</strong> Rezervasyon yapmadan ayrılan kullanıcılara %10 indirim reklamı."
      ]
    },
    {
      type: "heading",
      value: "Bütçe Belirleme",
      id: "butce-belirleme"
    },
    {
      type: "paragraph",
      value: "<strong>Google Harita reklam bütçesi</strong> belirlerken, sektör, rekabet, lokasyon ve hedeflerinizi dikkate almalısınız:"
    },
    {
      type: "table",
      caption: "Sektöre Göre Aylık Bütçe Önerileri (İstanbul)",
      headers: ["Sektör", "Minimum Aylık", "Orta Seviye", "Yüksek Rekabet", "Ortalama CPC"],
      rows: [
        ["Restoran/Kafe", "6.000 TL", "12.000 TL", "25.000 TL", "4-8 TL"],
        ["Sağlık Hizmetleri", "9.000 TL", "18.000 TL", "40.000 TL", "10-25 TL"],
        ["Ev Hizmetleri", "4.500 TL", "9.000 TL", "20.000 TL", "5-12 TL"],
        ["Otomotiv", "7.500 TL", "15.000 TL", "30.000 TL", "6-15 TL"],
        ["Güzellik & Bakım", "6.000 TL", "12.000 TL", "22.000 TL", "5-10 TL"],
        ["Hukuk/Danışmanlık", "12.000 TL", "25.000 TL", "60.000 TL", "15-40 TL"]
      ]
    },
    {
      type: "paragraph",
      value: "Bu bütçeler İstanbul için ortalama değerlerdir. Ankara, İzmir gibi diğer büyük şehirlerde %20-30 daha düşük, küçük illerde %40-50 daha düşük bütçe ile başlayabilirsiniz."
    },
    {
      type: "subheading",
      value: "Bütçe Optimizasyon İpuçları"
    },
    {
      type: "list",
      items: [
        "<strong>Başlangıç Stratejisi:</strong> İlk ay minimum bütçe ile başlayın, veri toplayın, sonra artırın.",
        "<strong>Dayparting:</strong> En yüksek dönüşüm saatlerine bütçenizin %60-70'ini ayırın.",
        "<strong>Coğrafi Bölgeleme:</strong> En çok müşteri gelen 3-5 mahalleye bütçenin %70'ini yönlendirin.",
        "<strong>Cihaz Optimizasyonu:</strong> Mobil CPC'yi %30-40 artırın, çünkü yerel aramaların %70'i mobilden yapılır.",
        "<strong>Negatif Kelimeler:</strong> İlgisiz aramaları hariç tutarak bütçenizi %15-20 koruyun.",
        "<strong>Rakip Analizi:</strong> Auction Insights raporunu inceleyin, rakiplerinizin bütçesini tahmin edin."
      ]
    },
    {
      type: "heading",
      value: "Case Study: Yerel Restoran Başarı Hikayesi",
      id: "case-study"
    },
    {
      type: "paragraph",
      value: "<strong>Müşteri:</strong> İstanbul Kadıköy'de orta segment bir balık restoranı."
    },
    {
      type: "paragraph",
      value: "<strong>Sorun:</strong> Hafta içi doluluk oranı %40, hafta sonu %90 ancak çevredeki yeni açılan 5 restoran nedeniyle rezervasyonlar azalıyor."
    },
    {
      type: "paragraph",
      value: "<strong>Uygulanan Strateji:</strong>"
    },
    {
      type: "list",
      items: [
        "<strong>Kampanya:</strong> Local Search Ads + Local Campaigns kombinasyonu.",
        "<strong>Bütçe:</strong> Aylık 12.000 TL (günlük 400 TL), hafta sonu %50 artış.",
        "<strong>Hedefleme:</strong> Kadıköy, Moda, Caddebostan mahallelerinde 3 km yarıçap, 25-55 yaş arası.",
        "<strong>Zaman Hedefleme:</strong> Öğle 11:00-14:00 ve akşam 18:00-21:00 saatleri, teklif %40 artış.",
        "<strong>Reklam Uzantıları:</strong> Menü linki, online rezervasyon, telefon araması, Google yorumları.",
        "<strong>Görsel Strateji:</strong> Taze balık görselleri, deniz manzarası, müşteri yorumlarından oluşan carousel reklamlar.",
        "<strong>Özel Kampanyalar:</strong> Hafta içi öğle menüsü için %15 indirim, Google'da rezervasyon yapanlara hoş geldin ikramı."
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Sonuçlar (3 aylık süre):</strong>"
    },
    {
      type: "list",
      items: [
        "📞 <strong>Telefon Aramaları:</strong> Aylık 280 arama (kampanya öncesi 120), %133 artış.",
        "📍 <strong>Yol Tarifi Tıklamaları:</strong> Aylık 520 tıklama (kampanya öncesi 180), %189 artış.",
        "📅 <strong>Online Rezervasyonlar:</strong> Aylık 95 rezervasyon (kampanya öncesi 30), %217 artış.",
        "💰 <strong>Ortalama CPC:</strong> 6,50 TL, telefon araması başına maliyet 14 TL.",
        "📈 <strong>ROI:</strong> Ortalama masa başı ciro 800 TL, reklam harcamasının 5,2 katı geri dönüş.",
        "🏆 <strong>İş Sonuçları:</strong> Hafta içi doluluk oranı %65'e yükseldi, rezervasyonların %40'ı Google Haritalar'dan geldi."
      ]
    },
    {
      type: "paragraph",
      value: "<a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">google ads reklam ajansı</a> ile yerel işletmenizi büyütün. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Dijital Mustafa</a> sektörünüze özel stratejiler geliştiriyor, ROI'nizi maksimize ediyorum."
    },
    {
      type: "paragraph",
      value: "<strong>Google Harita reklam verme</strong>, yerel işletmeler için en etkili ve ROI'sı en yüksek dijital pazarlama yöntemidir. Doğru kampanya tipi, sektöre özel strateji, optimize edilmiş bütçe ve sürekli performans takibi ile işletmenize %300-500 daha fazla müşteri kazandırabilirsiniz. Yerel rekabette öne geçmek için hemen bugün Google Harita reklamlarına başlayın!"
    }
  ]
};

export default googleHaritaReklamVermeContent;
